module.exports = __webpack_public_path__ + "img/unknown-user3.24f50860.jpg";